<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="服务商名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入服务商名称" v-trim/>
      </el-form-item>
      <el-form-item label="LOGO图片" prop="logo">
        <UploadAvatarImage :uploadData="uploadData" :file="file" @uploadSuccess="getFiles" />
      </el-form-item>
      <el-form-item label="所属行业" prop="industryId">
        <el-select v-model="form.industryId" placeholder="请选择">
          <el-option
            v-for="item in industry"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务星级" prop="starLevel">
        <el-select v-model="form.starLevel" placeholder="请选择">
          <el-option
            v-for="item in 5"
            :key="item"
            :label="item + '级'"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="linkName">
        <el-input v-model="form.linkName" placeholder="请输入联系人姓名" v-trim/>
      </el-form-item>
      <el-form-item label="联系人电话" prop="linkPhone">
        <el-input v-model="form.linkPhone" maxlength="11" placeholder="请输入联系人电话" v-trim/>
      </el-form-item>
      <el-form-item label="简介" prop="introduction">
        <el-input type="textarea" :autosize="{ minRows: 12, maxRows: 6 }" v-model="form.introduction" placeholder="请输入简介" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import { list } from '@/api/business/labels'
export default {
  name: 'OperaServerProviderWindow',
  extends: BaseOpera,
  components: { GlobalWindow, UploadAvatarImage },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        logo: '',
        industryId: '',
        starLevel: '',
        linkName: '',
        linkPhone: '',
        introduction: ''
      },
      file: {
        imgurl: '',
        imgurlfull: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请上传', trigger: 'blur' }
        ]
      },
      uploadData: {
        folder: 'znzz/logo_file',
        type: 'image'
      },
      industry: []
    }
  },
  created () {
    this.config({
      api: '/business/serverProvider',
      'field.id': 'id'
    })
  },
  methods: {
    getFiles(e) {
      this.file.imgurl = e.imgurl
      this.file.imgurlfull = e.imgurlfull
      this.form.logo = e.imgurl
    },
    open (title, target) {
      this.title = title
      this.getAll()
      this.visible = true
      // 新建
      if (target == null) {
        this.file.imgurlfull = ''
        this.file.imgurl = ''
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.file.imgurlfull = target.fullLog
        this.file.imgurl = target.logo
      })
    },
    async getAll() {
      this.industry = await list({ type: 1, isdeleted: 0 })
    }
  }
}
</script>
